import React from "react";
import "./StepOne.css";
import { Button, Typography } from "@mui/material";
import { stepOneData } from "../stepsData";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUp } from "@fortawesome/free-solid-svg-icons";
import tongueOut from "../../../../Assets/Images/tongue-out.png";

const StepOne = () => {
  return (
    <>
      <div>
        <Typography
          sx={{ fontSize: "23.8532px", fontFamily: "'Archivo', sans-serif" }}
          className="archivo fw-bold"
        >
          {stepOneData[0].stepOneHeading}
        </Typography>
        <div className="mt-2">
          <Typography
            sx={{
              fontSize: 16,
              lineHeight: "24px",
              fontFamily: "'Archivo', sans-serif",
            }}
            className="archivo"
          >
            {stepOneData[0].creditScoreInfo}
          </Typography>
        </div>
        <div className="mt-2">
          <Typography
            sx={{
              fontSize: 16,
              lineHeight: "24px",
              fontFamily: "'Archivo', sans-serif",
            }}
            className="archivo"
          >
            {stepOneData[0].categoryHeading}
          </Typography>

          <ul
            style={{ listStyle: "disc", fontSize: 16, color: "#1f1f1f" }}
            className=" archivo"
          >
            {stepOneData[0].creditScoreList &&
              stepOneData[0].creditScoreList.map((item, index) => (
                <li key={index}>
                  <strong>{item.head}</strong> {item.info}
                </li>
              ))}
          </ul>
        </div>

        <div className="tips mt-4 ">
          <div id="border_line"></div>
          <div id="tip__container" className="px-2 px-sm-4 py-4">
            <div className="px-3 py-2">
              <div className="d-flex flex-row gap-2 align-items-center">
                <img src={tongueOut} alt="" style={{ width: 30, height: 30 }} />
                <Typography
                  sx={{
                    fontSize: 16,
                    lineHeight: "24px",
                    letterSpacing: "0.08px",
                    color: "#59266D",
                    // color: "yellow",
                    fontFamily: "'Archivo', sans-serif",
                  }}
                >
                  MinEmi Tip:
                </Typography>
              </div>
              <div className="mt-2">
                <Typography
                  sx={{
                    fontSize: 16,
                    lineHeight: "24px",
                    letterSpacing: "0.08px",
                    color: "#1F1F1F",
                    // color: "#f8f8f8",

                    fontFamily: "'Archivo', sans-serif",
                  }}
                >
                  {" "}
                  Check your score for free on Minemi, and review your credit
                  report from credit bureaus like CIBIL or Experian. Correct any
                  errors that might affect your score, and prioritize timely
                  payments and low credit utilization.
                </Typography>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Button
        sx={{
          textTransform: "none",
          margin: "0px",
          fontSize: 16,
          fontFamily: "'Archivo', sans-serif",
        }}
        onClick={() => {
          window.scroll(0, 0);
        }}
        className="d-flex algin-items-center archivo mt-2"
      >
        <FontAwesomeIcon icon={faArrowUp} /> &nbsp; Back To Top
      </Button>
    </>
  );
};

export default StepOne;
